// Import all images
import heroImg from './images/hero-img.webp';
import aboutImg from './images/about.webp';
import about2Img from './images/about2.webp';

// Import GIF
import heroGif from './video/impetusvideoreel.gif';

// Import gallery images
import event1 from './images/events-1.webp';
import event2 from './images/events-2.webp';
import event3 from './images/events-3.webp';
import event4 from './images/events-4.webp';
import event5 from './images/events-5.webp';
import event6 from './images/events-6.webp';
import event7 from './images/events-7.webp';
import event8 from './images/events-8.webp';
import event9 from './images/events-9.webp';
import event10 from './images/events-10.webp';
import event11 from './images/events-11.webp';
import event12 from './images/events-12.webp';
import event13 from './images/events-13.webp';
import event14 from './images/events-14.webp';
import event15 from './images/events-15.webp';
import event16 from './images/events-16.webp';
import event17 from './images/events-17.webp';
import event18 from './images/events-18.webp';
import event19 from './images/events-19.webp';
import event20 from './images/events-20.webp';
import event21 from './images/events-21.webp';
import event22 from './images/events-22.webp';
import event23 from './images/events-23.webp';
import event24 from './images/events-24.webp';

export const images = {
  hero: heroImg,
  heroGif: heroGif,
  about: aboutImg,
  about2: about2Img,
  events: [
    event1, event2, event3, event4, event5, event6, event7, event8,
    event9, event10, event11, event12, event13, event14, event15, event16,
    event17, event18, event19, event20, event21, event22, event23, event24
  ]
};
